import TabMenu from '@/components/tab_menu/TabMenu.vue';
import AccountInfo from '@/components/account_info/AccountInfo.vue';
import TripList from '@/components/trip_list/TripList.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('User');

export default {
  name: 'UserInfo',
  components: { AccountInfo, TabMenu, TripList },

  data: () => ({
    tabMenu: {
      items: {
        account: {
          label: 'Accounts'
        },
        myTrips: {
          label: 'My Trips'
        }
      },
      currentTab: 'account'
    }
  }),

  computed: {
    ...mapUserState({
      currentUser: state => state.currentUser
    })
  }
};
